exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload[data-v-28819a2d] {\n  border-radius: 0.020833rem;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.avatar-uploader .el-upload[data-v-28819a2d]:hover {\n  border-color: #c5171e;\n}\n.avatar-uploader-icon[data-v-28819a2d] {\n  font-size: 0.145833rem;\n  color: #8c939d;\n  width: 0.9375rem;\n  height: 0.625rem;\n  line-height: 0.625rem;\n  text-align: center;\n}\n.avatar[data-v-28819a2d] {\n  width: 0.9375rem;\n  height: 0.625rem;\n  display: block;\n}", ""]);

// exports
